import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { ButtonHeading, CityDropdownForTrip, CommonDateRange, CommonInput, CommonModal, CustomPagination, CustomSelect } from 'components'
import { deleteConsignorData } from '_services/accountsServices/consignorServices';
import StorageService from "utils/StorageServices/StorageServices";
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { deleteZoneData, getZoneListData } from '_services/accountsServices/zoneServices';

import BootstrapTable from 'components/BootstrapTable';
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import MastersFilterModal from 'modals/MastersFilterModal';
import { constant } from 'constants/constant';
import { deleteVehicleGroupData, getVehicleGroupListData } from '_services/accountsServices/vehicleGroupServices';
import { UserContext } from 'context';
import useDocumentTitle from 'hooks/useDocumentTitle';
import AddEditVehicleDocTypeModel from 'modals/AddEditVehicleDocTypeModel/AddEditVehicleDocTypeModel';
import { deleteVehicleDocData, getVehicleDocTypeListData } from '_services/accountsServices/vehicleDocTypeServices';
import { CiLock, CiUnlock } from 'react-icons/ci';
import { deleteManufacturer, deleteStore, getItemsList, getManufacturerList, getPartCategoryList, getStoreList } from '_services/workShopServices/workShopServices';
import AddEditStoreModel from 'modals/AddEditStoreModel';
import { AddEditManufacturerModel } from 'modals';
import { utils } from 'helper';
import moment from 'moment';

const Inventory = () => {
  useDocumentTitle("Workshop Inventory | T360");

  const { settingChild } = useContext(UserContext);
  const [manufacturerModelData, setManufacturerModelData] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [inventoryDataList, setInventoryDataList] = useState([])
  const [loading, setLoading] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const prevFilterRef = useRef();
  const itemsPerPage = 25;
  const [totalItems, setTotalItems] = useState(0);
  const [filter, setFilter] = useState({
    limit: 25,
    offset: 1,
    search: '',
    category_id: {},
    manufacturer_id: {},
    // start_date: '',
    // end_date: '',
  });
  const [selectedRange, setSelectedRange] = useState({
    startDate: '', // moment().startOf("month")
    endDate: '', // moment().endOf("month")
  });

  const toggleStoreModelData = () => {
    setManufacturerModelData(!manufacturerModelData);
  };

  const getDataManufacturerList = async () => {
    try {
      let object = {
        ...filter,
        category_id: filter?.category_id?.value,
        manufacturer_id: filter?.manufacturer_id?.value,
        company_id: StorageService.getCompanyId(),
        type: 1
      }
      const res = await getItemsList(object);
      if (res?.responseCode == 200) {
        setInventoryDataList(res?.data?.itemData);
        setTotalItems(res?.data?.total_record);
      }
    } catch (error) {
      // throw error;
    }
  }

  useEffect(() => {
    const prevFilter = prevFilterRef.current;
    if (
      JSON.stringify(prevFilter) !== JSON.stringify(filter)
    ) {
      getDataManufacturerList();
      prevFilterRef.current = filter;
    }
  }, [filter, manufacturerModelData])

  const deleteHandler = (item) => {
    setIsDelete(item)
  }

  const submitDeleteStore = async (itemData) => {
    setLoading(true);
    try {
      let object = {}
      if (itemData?.disable) {
        object['id'] = itemData?._id;
        object['status'] = (itemData?.status === 1) ? 3 : 1;
      } else {
        object['id'] = isDelete?._id;
        object['status'] = 2;
      }
      const res = await deleteManufacturer(object);
      if (res?.responseCode == 200) {
        toast.success(`${res?.responseMessage}`);
        getDataManufacturerList();
        setLoading(false);
        setIsDelete(false);
      } else {
        if (res?.responseMessage) {
          toast.error(res?.responseMessage);
        }
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      // throw error;
    }
  }

  let propsObject = {
    isOpen: isDelete,
    closeModal: setIsDelete,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitDeleteStore,
    isLoadding: loading,
  }

  let manufacturerModelProps = {
    isOpen: manufacturerModelData,
    closeModal: (e) => setManufacturerModelData(false),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: manufacturerModelData?.isDetails ? "View Manufacturer" : (manufacturerModelData?._id ? 'Update Manufacturer' : 'Add Manufacturer'),
    submitTitle: manufacturerModelData?.isDetails ? "View Manufacturer" : (manufacturerModelData?._id ? 'Update Manufacturer' : 'Add Manufacturer'),
    footerPart: manufacturerModelData?.isDetails ? true : false,
    hideFooterSumbmitBtn: manufacturerModelData?.isDetails ? true : false,
    hideCompletelyFoolter: manufacturerModelData?.isDetails ? true : false,
    ApiCall: getDataManufacturerList
  }

  const columns = [
    { header: "", accessor: "serial" },
    { header: "Part Code", accessor: "part_code" },
    { header: "Part Name", accessor: "part_name" },
    { header: "Store", accessor: "store" },
    { header: "Opening", accessor: "opening" },
    { header: "Purchased", accessor: "purchased" },
    { header: "Allocated", accessor: "allocated" },
    { header: "Adjustment", accessor: "adjustment" },
    { header: "In Stock", accessor: "in_stock" },
    { header: "Status", accessor: "status" },
  ];

  const rowListData = (data) => {
    return data?.map((item, i) => ({
      ...item,
      serial: <>
        <div className="signDropdown">
          <button className="dropbtn11">
            <BsThreeDotsVertical />
          </button>
          <div className="dropdownContent">
            <div className='_avPointer'>
              <span className='_samAnchor'>
                <span className='editIcon_avt'>
                  <AiOutlineEye />
                </span>
                View
              </span>
            </div>

            <div className='_avPointer'>
              <span className='_samAnchor'>
                <span className='editIcon_avt'>
                  <FiEdit />
                </span>
                Edit
              </span>
            </div>

            <div className='_avPointer'>
              <span className='_samAnchor'>
                <span className='deleteIcon_avt'>
                  <FaRegTrashCan color='red' />
                </span>
                Delete
              </span>
            </div>
          </div>
        </div>
      </>,
      part_code: <>{item?.code ? item?.code : '-'}</>,
      part_name: <>{item?.category_number ? item?.category_number : '-'}</>,
      store: <>{item?.store?.name ? item?.store?.name : '-'}</>,
      opening: <>{item?.opening_stock ? item?.opening_stock : '-'}</>,
      purchased: <>{item?.purchased_stock ? item?.purchased_stock : '-'}</>,
      allocated: <>{item?.allocated_stock ? item?.allocated_stock : '-'}</>,
      adjustment: <>{item?.adjusted_stock ? item?.adjusted_stock : '-'}</>,
      in_stock: <>{item?.stock_in_hand ? item?.stock_in_hand : '-'}</>,
      status: <div style={{ color: (item?.status === 1) ? "green" : "red" }}>{item?.status ? constant.ActionStore.find((el) => el?.value === item?.status)?.label : '-'}</div>,
    }));
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }))
  };

  const fetchPartCategory = useCallback(async (search, page, limit) => {
    try {
      const response = await getPartCategoryList({
        company_id: StorageService.getCompanyId(),
        offset: page,
        limit,
        search,
        status: 1
      });

      if (response?.responseCode === 200) {
        const vendors = response.data.partData.map(vendor => ({
          ...vendor,
          label: vendor.name,
          value: vendor._id
        }));

        return {
          items: vendors,
          total: response.data.total_record || vendors.length,
        };
      }

      toast.error(response?.responseMessage);
      return { items: [], total: 0 };
    } catch (error) {
      return { items: [], total: 0 };
    }
  }, []);

  const fetchManufacturer = useCallback(async (search, page, limit) => {
    try {
      const response = await getItemsList({
        company_id: StorageService.getCompanyId(),
        offset: page,
        limit,
        search,
      });

      if (response?.responseCode === 200) {
        const vendors = response.data.itemData.map(vendor => ({
          ...vendor,
          label: vendor.name,
          value: vendor._id
        }));

        return {
          items: vendors,
          total: response.data.total_record || vendors.length,
        };
      }

      toast.error(response?.responseMessage);
      return { items: [], total: 0 };
    } catch (error) {
      return { items: [], total: 0 };
    }
  }, []);

  const handleApply = (newRange) => {
    setSelectedRange(newRange);
    setFilter((prev) => ({
      ...prev,
      start_date: moment(newRange.startDate).format("YYYY-MM-DD"),
      end_date: moment(newRange.endDate).format("YYYY-MM-DD"),
      offset: 1,
    }));
  };

  const handleReset = () => {
    setFilter(((s) => ({
      ...s,
      limit: 25,
      offset: 1,
      search: '',
      category_id: {},
      manufacturer_id: {},
      start_date: '',
      end_date: '',
    })));
    setSelectedRange({
      startDate: '',
      endDate: '',
    })
  };

  return (
    <div className="__profilCmp_main">
      <ButtonHeading
        title={"Inventory"}
        onClick={() => { }} // toggleStoreModelData
        buttonTitle="Add Inventory"
        showSearchFilter={{ search: false, filterOption: false, filterCount: true }}
        onClickFilterModal={(e) => setShowFilterModal(!showFilterModal)}
        filter={filter}
        setFilter={setFilter}
        isDebouncedSearch={true}
      />

      <div className='pd_manufactoer'>
        <div className='__filtsTb_flexMain'>
          <div className='__filtsTb_flex'>
            <div className='__fInx_bx'>
              <CityDropdownForTrip
                label="Part Category"
                placeholder="Part Category"
                fetchData={fetchPartCategory}
                pageSize={20}
                selectedItem={filter.category_id ? filter?.category_id : null}
                onChange={(data) => setFilter((s) => ({ ...s, category_id: data }))}
              />
            </div>
            <div className='__fInx_bx'>
              <CityDropdownForTrip
                label="Part Company"
                placeholder="Part Company"
                fetchData={fetchManufacturer}
                pageSize={20}
                selectedItem={filter.manufacturer_id ? filter?.manufacturer_id : null}
                onChange={(data) => setFilter((s) => ({ ...s, manufacturer_id: data }))}
              />
            </div>
            <div className='__fInx_bx'>
              <CommonDateRange
                initialStartDate={selectedRange.startDate || ""}
                initialEndDate={selectedRange.endDate || ""}
                onApply={handleApply}
                datePrefield={!!(selectedRange.startDate && selectedRange.endDate)}
              />
            </div>
            <div className='__fInx_bx'>
              <CommonInput
                type="search"
                label='Search'
                placeholder='Search'
                name='search'
                value={filter.search}
                maxLength="30"
                onInput={utils.maxLengthCheck}
                onChange={(e) => setFilter((s) => ({ ...s, search: e.target.value }))}
              />
            </div>
            {(filter.search || filter?.start_date || filter?.end_date || filter?.category_id?.value || filter?.manufacturer_id?.value) ? <div>
              <button
                className='manuRsret'
                onClick={handleReset}
              >
                Clear
              </button>
            </div> : <></>}
          </div>
        </div>
      </div>
      <div className='_tabWith_outTab'>
        <BootstrapTable
          columns={columns}
          data={rowListData(inventoryDataList?.length > 0 ? inventoryDataList : [])}
        // isLoading={loading}
        />

        {inventoryDataList?.length ? <div className='paginationFt_avt'>
          <CustomPagination
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            currentPage={filter.offset}
            onPageChange={handlePageChange}
          />
        </div> : <></>}
      </div>

      {
        manufacturerModelData
        && (
          <AddEditManufacturerModel {...manufacturerModelProps} />
        )
      }

      {
        isDelete?._id && (
          <CommonModal {...propsObject}>
            <p className='p-3'> Are you sure you want to delete {isDelete?.name} ?</p>
          </CommonModal>
        )
      }

    </div >
  )
}

export default Inventory